"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiBold = function IconUiBold(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M38.763 40.474a9.218 9.218 0 0 0 3.684-7.421 8.526 8.526 0 0 0-3.368-7q-2.264-1.9-7.895-3.211 5.211-1.368 7.263-3.579a7.184 7.184 0 0 0 2.211-5.158A8.615 8.615 0 0 0 38.921 8.9a10.806 10.806 0 0 0-4.474-3.684Q31.606 4 24.816 4H5.553v1.053a10.586 10.586 0 0 1 3.847.473A3.939 3.939 0 0 1 10.711 7q.472.736.473 4.105v25.842q0 3.212-.473 4A2.4 2.4 0 0 1 9.4 42.368a10.558 10.558 0 0 1-3.842.474V44h20.31q8.421 0 12.895-3.526zM20.342 6.368q4.474-.158 6.369.79a6.451 6.451 0 0 1 3 2.526 8.43 8.43 0 0 1 1 4.263 9.081 9.081 0 0 1-1 4.474 6.845 6.845 0 0 1-3.158 2.684 14.845 14.845 0 0 1-6.211.948zm.947 34.579a2.973 2.973 0 0 1-.947-2.421v-14.21a23.289 23.289 0 0 1 6.842.737 8.706 8.706 0 0 1 3.684 3.21 10.543 10.543 0 0 1 1.211 5.053 9.653 9.653 0 0 1-1.053 4.473 8.605 8.605 0 0 1-3.052 3 9.953 9.953 0 0 1-4.316 1 3.2 3.2 0 0 1-2.369-.842z"
  }));
};

IconUiBold.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiBold;
exports.default = _default;